import React from "react";

export default function BsPinMapFill() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        clipPath="url(#h)"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#currentColor"
      >
        <path d="M4.65 16.882a.75.75 0 0 1 .6-.3H9a.75.75 0 1 1 0 1.5H5.625l-3.375 4.5h19.5l-3.375-4.5H15a.75.75 0 1 1 0-1.5h3.75a.75.75 0 0 1 .6.3l4.5 6a.75.75 0 0 1-.6 1.2H.75a.75.75 0 0 1-.6-1.2l4.5-6Z" />
        <path d="M6 6.081a6 6 0 1 1 6.75 5.954v8.296a.75.75 0 1 1-1.5 0v-8.294A6 6 0 0 1 6 6.08v.001Z" />
      </g>
      <defs>
        <clipPath id="h">
          <path fill="#fff" transform="translate(0 .082)" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
